export default __webpack_public_path__ + "static/media/club125.ecdbc7a2.jpg";